// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__D9-2w","inputWrap":"Table_inputWrap__Ifr5Q","col":"Table_col__20Wqj","bmiTooltip":"Table_bmiTooltip__3rdru"};